import { useState as i, useEffect as I } from "react";
import { hasVariants as y, getDefaultVariant as g, getIconImport as $ } from "./index27.mjs";
import { LRUCache as E } from "./index22.mjs";
const l = new E(100);
function V(r, p) {
  const [m, s] = i({
    component: null
  }), [d, t] = i(!1), [h, c] = i(!1);
  return I(() => {
    if (s({ component: null }), t(!1), c(!1), !r) return;
    const o = r;
    let n;
    y(o) ? n = p || g(o) : n = void 0;
    const a = n ? `${o}:${n}` : o;
    if (l.has(a)) {
      s({ component: l.get(a) });
      return;
    }
    const u = $(o, n);
    if (!u) {
      c(!0);
      return;
    }
    t(!0), u().then((f) => {
      const e = f.default;
      typeof e == "function" || e && typeof e == "object" && "$$typeof" in e ? (l.set(a, e), s({ component: e }), t(!1)) : (console.error(
        `Invalid icon component for "${o}". Expected function or React component, got:`,
        typeof e
      ), c(!0), t(!1));
    }).catch((f) => {
      console.warn(`Failed to load icon "${o}":`, f), c(!0), t(!1);
    });
  }, [r, p]), {
    component: m.component,
    isLoading: d,
    hasError: h
  };
}
export {
  V as useIconLoader
};
